import L from 'leaflet';
import { useEffect, useState } from 'react';
import { defaultOptions } from '../constants';
const getWeight = (options) => (options && options.weight ? options.weight : defaultOptions.weight) +
    (options && options.tolerance ? options.tolerance : defaultOptions.tolerance);
function useEventPolylines(map, hotline, data, getLat, getLng, options, eventHandlers) {
    const [polylines, setPolylines] = useState([]);
    const poylineOptions = {
        color: 'red',
        weight: getWeight(options),
        opacity: 0,
    };
    const createPolyline = (_data, i) => {
        const latlngs = _data.map((d) => ({
            lat: getLat(d, i),
            lng: getLng(d, i),
        }));
        const polyline = L.polyline(latlngs, poylineOptions);
        attachEventHandlers(polyline, i);
        return polyline.addTo(map);
    };
    const attachEventHandlers = (polyline, i) => {
        if (eventHandlers === undefined)
            return;
        Object.entries(eventHandlers).forEach(([k, v]) => {
            polyline.on(k, (e) => v(e, i, polyline));
        });
    };
    useEffect(() => {
        if (eventHandlers === undefined || hotline === undefined)
            return;
        const _polylines = Array.isArray(data[0])
            ? data.map((d, i) => createPolyline(d, i))
            : [createPolyline(data, 0)];
        setPolylines(_polylines);
        return () => {
            _polylines.forEach((p) => p.remove());
        };
    }, [data, hotline]);
    useEffect(() => {
        if (polylines === undefined)
            return;
        polylines.forEach(attachEventHandlers);
    }, [eventHandlers]);
    return null;
}
export default useEventPolylines;
